import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { QuestionType } from '@/components/campaigns/CampaignQuestionsEditor/types';

import type { CampaignQuestionWithAnswer } from '@/components/campaigns/CampaignQuestionsEditor/types';

interface QuestionTitleProps {
    question: CampaignQuestionWithAnswer;
    index: number;
}

/**
 * Before title field has been added, formulas used question text as a title.
 *
 * @param {CampaignQuestionWithAnswer} question
 * @returns {string}
 */
const resolveTitle = (question: CampaignQuestionWithAnswer): string => {
    if (question.type === QuestionType.FORMULA) {
        return question.title || question.text || 'Question';
    }

    return question.title || 'Question';
};

const QuestionTitle: React.FC<QuestionTitleProps> = ({ question, index }) => {
    const title = useMemo(() => resolveTitle(question), [question]);
    const titleToDisplay = `${index + 1}. ${title}`;

    return (
        <>
            <Typography variant="h4" sx={{ fontSize: '14px', fontWeight: 'bold', mb: 0.5, wordBreak: 'break-word' }}>
                {titleToDisplay}
            </Typography>
            {question.type !== QuestionType.FORMULA && (
                <Typography variant="body2" sx={{ mb: 0.75, wordBreak: 'break-word' }}>
                    {question.text}
                </Typography>
            )}
        </>
    );
};

export default QuestionTitle;
